import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BlogCTAButtons from "@/components/BlogCTAButtons";
import CanonicalTag from "@/components/CanonicalTag";
import FloatingADUWizard from "@/components/FloatingADUWizard";
import FloatingReserveButton from "@/components/FloatingReserveButton";
import heroImage from "@/assets/what-can-you-build-adu-zoning.png";

const BlogADUZoningExplained = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": "What Can You Build on Your Property? ADU Zoning Explained",
    "description": "Know your real options before you start. Learn how zoning, setbacks, and city rules affect what ADU you can build.",
    "image": heroImage,
    "datePublished": "2026-04-02",
    "author": { "@type": "Organization", "name": "UDA ADU" },
    "publisher": { "@type": "Organization", "name": "UDA ADU" },
  };

  return (
    <div className="min-h-screen bg-background">
      <CanonicalTag url="https://www.udaadu.com/blogs/adu-zoning-explained" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
      <Navigation />

      <div className="w-full max-w-5xl mx-auto px-4 pt-8">
        <img src={heroImage} alt="What can you build on your property - ADU zoning explained" className="w-full rounded-2xl" />
      </div>

      <main className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/blogs" className="inline-flex items-center text-muted-foreground hover:text-foreground mb-8 transition-colors">
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Blog
        </Link>

        <p className="text-sm text-muted-foreground mb-2">April 2, 2026</p>
        <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-8">
          What Can You Build on Your Property? ADU Zoning Explained
        </h1>

        <article className="prose prose-lg max-w-none text-muted-foreground space-y-6">
          <p>One of the first questions we get is simple. What can I build on my property?</p>
          <p>The answer depends on more than just lot size. Zoning, setbacks, easements, and existing structures all play a role. Two homes on the same street can have completely different ADU options.</p>
          <p>This is where most projects either move forward smoothly or get stuck.</p>
          <p>We start every project by breaking down the property. We look at city rules, we review the site, and we map out realistic options. No guessing, no overpromising.</p>
          <p>Permits in cities like Los Altos, San Jose, and Palo Alto can be strict. But when the plans are right from the beginning, the process becomes manageable.</p>
          <p>A well-planned ADU is not complicated. It's just done in the right order.</p>
        </article>

        <BlogCTAButtons />
      </main>

      <FloatingADUWizard />
      <FloatingReserveButton />
      <Footer />
    </div>
  );
};

export default BlogADUZoningExplained;
